import {Howl, Howler} from 'howler';

if(!window.backgroundMusic && siteBGTrack) {
  window.backgroundMusic = new Howl({
    src: [siteBGTrack.url],
    loop: true,
    volume: 0.1
  });
}
